'use client';

import { CartIcon } from '@c/icons';
import { useAnimation } from 'framer-motion';
import { MotionDiv } from 'motion';

export const AddToCartButton = ({
  handleAddToCart,
}: {
  handleAddToCart: () => void;
}) => {
  const addToCartButtonControls = useAnimation();

  return (
    <MotionDiv
      className="z-50 flex w-[20rem] items-center justify-center gap-x-2 rounded-full bg-brand-secondary p-4"
      initial={{ height: '4.5rem', width: '4.5rem' }}
      whileHover={{
        width: '23rem',
        transition: { duration: 0.3, ease: 'linear' },
      }}
      onHoverStart={() =>
        addToCartButtonControls.start({
          opacity: 1,
          display: 'block',
          x: 0,
          transition: { duration: 0.5, ease: 'linear' },
        })
      }
      onHoverEnd={() =>
        addToCartButtonControls.start({
          opacity: 0,
          display: 'none',
          x: -20,
          transition: { duration: 0.5, ease: 'linear' },
        })
      }
      onClick={handleAddToCart}
    >
      <CartIcon className="h-10 w-10 text-white" />

      <MotionDiv
        initial={{ opacity: 0, x: -20, display: 'none' }}
        animate={addToCartButtonControls}
      >
        <span className="whitespace-nowrap font-semibold text-white">
          Add to Cart
        </span>
      </MotionDiv>
    </MotionDiv>
  );
};
